import { render, staticRenderFns } from "./MessagePreview.vue?vue&type=template&id=90a66d0a&scoped=true"
import script from "./MessagePreview.vue?vue&type=script&lang=js"
export * from "./MessagePreview.vue?vue&type=script&lang=js"
import style0 from "./MessagePreview.vue?vue&type=style&index=0&id=90a66d0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a66d0a",
  null
  
)

export default component.exports